import React from "react";
import { Box, Text } from "@chakra-ui/react";
const UnAuthorized = () => {
  return (
    <>
      <Box
        pos="fixed"
        w="100%"
        h="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={999}
        background="#000"
        flexDirection="column"
      >
        {/* <Box mb={4}>
          <img alt="AceOdds.in" src={require("../../assets/aceodds-logo.png")} />
        </Box> */}
        <Box className="no-auth-box">
          <Text className="oops">Oops!</Text>
          <Text className="a-text">You are not authrized!</Text>
        </Box>
      </Box>
    </>
  );
};

export default UnAuthorized;
